import { Chip, SxProps, Theme } from "@mui/material";
import { ClientViewAppointmentStatusColors, VisitStatus } from "@/types";
import { getVisitStatusLabel } from "@/utils/visit";

type Props = { status: VisitStatus; sx?: SxProps<Theme> };

export default function ClientViewAppointmentStatusChip({ status, sx }: Props) {
  return (
    <Chip
      label={getVisitStatusLabel(status)}
      color={ClientViewAppointmentStatusColors[status]}
      sx={sx}
    />
  );
}
